import React from "react";
import { Form } from "antd";
import StarLabelInputBox from "../../UI/StarLabelInputBox";
import "../../Styles/Users.css";

const PaymentInfo = ({ data, setData }) => {
  const [form] = Form.useForm();

  const onFinish = (values) => {
    console.log("Success:", values);
  };

  const onFinishFailed = (errorInfo) => {
    console.log("Failed:", errorInfo);
  };

  const handleChange = (e) => {
    setData({ ...data, [e.target.name]: e.target.value });
  };

  return (
    <div className="p-3">
      <Form>
        <div>
          <h6>Paypal</h6>
          <div>
            <span>
              <StarLabelInputBox
                label={"Sandbox client id"}
                important={false}
                onChange={handleChange}
              />
            </span>
            <p className="payment-tag">Required for instructor</p>
          </div>
          <div>
            <span>
              <StarLabelInputBox
                label={"Sandbox secret key"}
                important={false}
                onChange={handleChange}
              />
            </span>
            <p className="payment-tag">Required for instructor</p>
          </div>
          <div>
            <span>
              <StarLabelInputBox
                label={"Production client id"}
                important={false}
                onChange={handleChange}
              />
            </span>
            <p className="payment-tag">Required for instructor</p>
          </div>
          <div>
            <span>
              <StarLabelInputBox
                label={"Production secret key"}
                important={false}
                onChange={handleChange}
              />
            </span>
            <p className="payment-tag">Required for instructor</p>
          </div>
        </div>
        <hr></hr>

        <div>
          <h6>Stripe</h6>
          <div>
            <span>
              <StarLabelInputBox
                label={"Public key"}
                important={false}
                onChange={handleChange}
              />
            </span>
            <p className="payment-tag">Required for instructor</p>
          </div>
          <div>
            <span>
              <StarLabelInputBox
                label={"Secret key"}
                important={false}
                onChange={handleChange}
              />
            </span>
            <p className="payment-tag">Required for instructor</p>
          </div>
          <div>
            <span>
              <StarLabelInputBox
                label={"Public live key"}
                important={false}
                onChange={handleChange}
              />
            </span>
            <p className="payment-tag">Required for instructor</p>
          </div>
          <div>
            <span>
              <StarLabelInputBox
                label={"Secret live key"}
                important={false}
                onChange={handleChange}
              />
            </span>
            <p className="payment-tag">Required for instructor</p>
          </div>
        </div>
        <hr></hr>

        <div>
          <h6>Razorpay</h6>
          <div>
            <span>
              <StarLabelInputBox
                label={"Key id"}
                important={false}
                onChange={handleChange}
              />
            </span>
            <p className="payment-tag">Required for instructor</p>
          </div>
          <div>
            <span>
              <StarLabelInputBox
                label={"Secret key"}
                important={false}
                onChange={handleChange}
              />
            </span>
            <p className="payment-tag">Required for instructor</p>
          </div>
          <div>
            <span>
              <StarLabelInputBox
                label={"Theme color"}
                important={false}
                onChange={handleChange}
              />
            </span>
            <p className="payment-tag">Required for instructor</p>
          </div>
        </div>
        <hr></hr>

        <div>
          <h6>Xendit</h6>
          <div>
            <span>
              <StarLabelInputBox
                label={"Api key"}
                important={false}
                onChange={handleChange}
              />
            </span>
            <p className="payment-tag">Required for instructor</p>
          </div>
          <div>
            <span>
              <StarLabelInputBox
                label={"Secret key"}
                important={false}
                onChange={handleChange}
              />
            </span>
            <p className="payment-tag">Required for instructor</p>
          </div>
          <div>
            <span>
              <StarLabelInputBox
                label={"Other parameter"}
                important={false}
                onChange={handleChange}
              />
            </span>
            <p className="payment-tag">Required for instructor</p>
          </div>
        </div>
        <hr></hr>

        <div>
          <h6>Payu</h6>
          <div>
            <span>
              <StarLabelInputBox
                label={"Pos id"}
                important={false}
                onChange={handleChange}
              />
            </span>
            <p className="payment-tag">Required for instructor</p>
          </div>
          <div>
            <span>
              <StarLabelInputBox
                label={"Second key"}
                important={false}
                onChange={handleChange}
              />
            </span>
            <p className="payment-tag">Required for instructor</p>
          </div>
          <div>
            <span>
              <StarLabelInputBox
                label={"Client id"}
                important={false}
                onChange={handleChange}
              />
            </span>
            <p className="payment-tag">Required for instructor</p>
          </div>
          <div>
            <span>
              <StarLabelInputBox
                label={"Client secret"}
                important={false}
                onChange={handleChange}
              />
            </span>
            <p className="payment-tag">Required for instructor</p>
          </div>
        </div>
        <hr></hr>

        <div>
          <h6>Pagseguro</h6>
          <div>
            <span>
              <StarLabelInputBox
                label={"Api key"}
                important={false}
                onChange={handleChange}
              />
            </span>
            <p className="payment-tag">Required for instructor</p>
          </div>
          <div>
            <span>
              <StarLabelInputBox
                label={"Secret key"}
                important={false}
                onChange={handleChange}
              />
            </span>
            <p className="payment-tag">Required for instructor</p>
          </div>
          <div>
            <span>
              <StarLabelInputBox
                label={"Other parameter"}
                important={false}
                onChange={handleChange}
              />
            </span>
            <p className="payment-tag">Required for instructor</p>
          </div>
        </div>
        <hr></hr>

        <div>
          <h6>Ssl commerz</h6>
          <div>
            <span>
              <StarLabelInputBox
                label={"Store id"}
                important={false}
                onChange={handleChange}
              />
            </span>
            <p className="payment-tag">Required for instructor</p>
          </div>
          <div>
            <span>
              <StarLabelInputBox
                label={"Store password"}
                important={false}
                onChange={handleChange}
              />
            </span>
            <p className="payment-tag">Required for instructor</p>
          </div>
        </div>
        <hr></hr>

        <div>
          <h6>Skrill</h6>
          <div>
            <span>
              <StarLabelInputBox
                label={"Skrill merchant email"}
                important={false}
                onChange={handleChange}
              />
            </span>
            <p className="payment-tag">Required for instructor</p>
          </div>
          <div>
            <span>
              <StarLabelInputBox
                label={"Secret passphrase"}
                important={false}
                onChange={handleChange}
              />
            </span>
            <p className="payment-tag">Required for instructor</p>
          </div>
        </div>
        <hr></hr>

        <div>
          <h6>Doku</h6>
          <div>
            <span>
              <StarLabelInputBox
                label={"Client id"}
                important={false}
                onChange={handleChange}
              />
            </span>
            <p className="payment-tag">Required for instructor</p>
          </div>
          <div>
            <span>
              <StarLabelInputBox
                label={"Shared key"}
                important={false}
                onChange={handleChange}
              />
            </span>
            <p className="payment-tag">Required for instructor</p>
          </div>
        </div>
        <hr></hr>

        <div>
          <h6>Bkash</h6>
          <div>
            <span>
              <StarLabelInputBox
                label={"App key"}
                important={false}
                onChange={handleChange}
              />
            </span>
            <p className="payment-tag">Required for instructor</p>
          </div>
          <div>
            <span>
              <StarLabelInputBox
                label={"App secret"}
                important={false}
                onChange={handleChange}
              />
            </span>
            <p className="payment-tag">Required for instructor</p>
          </div>
          <div>
            <span>
              <StarLabelInputBox
                label={"Username"}
                important={false}
                onChange={handleChange}
              />
            </span>
            <p className="payment-tag">Required for instructor</p>
          </div>
          <div>
            <span>
              <StarLabelInputBox
                label={"Username"}
                important={false}
                onChange={handleChange}
              />
            </span>
            <p className="payment-tag">Required for instructor</p>
          </div>
        </div>
        <hr></hr>

        <div>
          <h6>Cashfree</h6>
          <div>
            <span>
              <StarLabelInputBox
                label={"Client id"}
                important={false}
                onChange={handleChange}
              />
            </span>
            <p className="payment-tag">Required for instructor</p>
          </div>
          <div>
            <span>
              <StarLabelInputBox
                label={"Client secret"}
                important={false}
                onChange={handleChange}
              />
            </span>
            <p className="payment-tag">Required for instructor</p>
          </div>
        </div>
        <hr></hr>

        <div>
          <h6>Maxicash</h6>
          <div>
            <span>
              <StarLabelInputBox
                label={"Merchant id"}
                important={false}
                onChange={handleChange}
              />
            </span>
            <p className="payment-tag">Required for instructor</p>
          </div>
          <div>
            <span>
              <StarLabelInputBox
                label={"Merchant password"}
                important={false}
                onChange={handleChange}
              />
            </span>
            <p className="payment-tag">Required for instructor</p>
          </div>
        </div>
        <hr></hr>

        <div>
          <h6>Aamarpay</h6>
          <div>
            <span>
              <StarLabelInputBox
                label={"Store id"}
                important={false}
                onChange={handleChange}
              />
            </span>
            <p className="payment-tag">Required for instructor</p>
          </div>
          <div>
            <span>
              <StarLabelInputBox
                label={"Signature key"}
                important={false}
                onChange={handleChange}
              />
            </span>
            <p className="payment-tag">Required for instructor</p>
          </div>
        </div>
        <hr></hr>

        <div>
          <h6>Flutterwave</h6>
          <div>
            <span>
              <StarLabelInputBox
                label={"Public key"}
                important={false}
                onChange={handleChange}
              />
            </span>
            <p className="payment-tag">Required for instructor</p>
          </div>
          <div>
            <span>
              <StarLabelInputBox
                label={"Secret key"}
                important={false}
                onChange={handleChange}
              />
            </span>
            <p className="payment-tag">Required for instructor</p>
          </div>
        </div>
        <hr></hr>

        <div>
          <h6>Tazapay</h6>
          <div>
            <span>
              <StarLabelInputBox
                label={"Public key"}
                important={false}
                onChange={handleChange}
              />
            </span>
            <p className="payment-tag">Required for instructor</p>
          </div>
          <div>
            <span>
              <StarLabelInputBox
                label={"Api key"}
                important={false}
                onChange={handleChange}
              />
            </span>
            <p className="payment-tag">Required for instructor</p>
          </div>
          <div>
            <span>
              <StarLabelInputBox
                label={"Api secret"}
                important={false}
                onChange={handleChange}
              />
            </span>
            <p className="payment-tag">Required for instructor</p>
          </div>
        </div>
        <hr></hr>
      </Form>
    </div>
  );
};

export default PaymentInfo;
